import React, { useEffect, useState } from 'react';
import Epa from '../../../assets/images/robo.png';
import axios from 'axios';
import { socket } from '../../../socket';
import { languages } from "../../utility/constants"
import { getCookie, deleteCookie, updateCookie, setCookie } from '../../utility/cookies';
import Robot from "../../../assets/images/robo.png"
import { btoa, toUnicode } from '../../../cryptographic/crypto';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import useSpeechSynthesis from '../../utility/useSpeechSynthesis';
import PauseIcon from '@mui/icons-material/Pause';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import GTranslateOutlinedIcon from '@mui/icons-material/GTranslateOutlined';
import GemsLogo from "../../../assets/images/gems-logo.png"

function Header({ messageSender, chatIsClose, setLangisClicked, changeLanguage, setCloseChatEff, addLangChangeinMsg, setChatIsClose,
    isLangChange, setIsLangChange, setCloseFloat, closeChatEff, closeChatHandler, setChangeLanguage, noFeedback, setNoFeedback, filteredLang, prefLang, setPrefLang, isLang, setIsLang, startChat, setStartChat, setOpenAbout, openAbout, openFeedback, setOpenFeedback, formRequested, setFormRequested, socket, events, botInfo, openBot, setOpenBot ,voiceEnabled,botCName,hideFooter,messagesEnd,setOpenMic,setOpenInfoModal}) {
    const [openMenu, setOpenMenu] = useState(false)
    const handleAbout = () => {
        setOpenAbout(!openAbout)
    }
    const windowGroupId = process.env.REACT_APP_PROD === "true" ? window.chat_widget_reference_no : process.env.REACT_APP_GROUPID
    const [openDrawer, setopenDrawer] = useState(false)
    const closeChat = () => {
        socket.emit(btoa(["close-chat", {}]));
        setOpenMenu(!openMenu)
        setFormRequested(false)
        console.log("check close chat 1", closeChatEff)
        updateCookie('appState', 'closeChat')
        updateCookie('appState', 'hasFeedback')
        setTimeout(() => {
            socket.emit(btoa(["close-chat", {}]));
        }, 500);
    }

    function generateRandomString() {
        const now = new Date();
        const timestamp = now.getTime();
        const randomNumber = Math.floor(Math.random() * 1000000);
        const randomString = `${timestamp}${randomNumber}`;
        return randomString;
    }
    
    const changeLanguageHanlder = (lang) => {
        // console.log("print the state")
        // console.log("this runs again ", prefLang, lang)
        let newSessionId = ''
        if (getCookie('sessionId')) {
            newSessionId = getCookie('sessionId')
        }else {
            newSessionId = generateRandomString()
            updateCookie("sessionId", newSessionId)
        }
        
        if (lang !== prefLang) {
            setOpenMenu(!openMenu)

            setLangisClicked(lang)
            // console.log("this runs again doesnt")
            updateCookie('hasFeedback', false)
            updateCookie('hasNoFeedback', false)
            setOpenFeedback(false)
            setNoFeedback(false)
            setPrefLang(lang)
            updateCookie('prefLang', lang)
            // setLangisClicked(true)
            // console.log("this runs again doesnt", prefLang)
            setIsLang(true)
            setChangeLanguage(true)
            // console.log("print it ")
            // console.log("value of lang 1", lang)
            // addLangChangeinMsg()
            setIsLangChange(lang)
            // console.log("value of lang", isLangChange)
            const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
            if(botType === "TlkDocs"){
                socket.io.opts.query = {q: btoa('type=user&page=chat&locale=' + lang + '&group=' + windowGroupId +'&session_id='+ window.sessionId +'&platform=talkkmesanger'+'&EIO=3&transport=websocket')};
            }else{
                socket.io.opts.query = {q: btoa('type=user&page=chat&locale=' + lang + '&group=' + windowGroupId +'&session_id='+ newSessionId + '&EIO=3&transport=websocket')};
            }
            socket.disconnect()
            socket.connect()
            startChatOnLanguageChange()
            if(lang === "cr"){
                setOpenMic(false)
            }
        }
        else {
            // console.log("this runs again does")
            setIsLangChange(false)
        }
    }

    useEffect(()=>{
        messagesEnd?.current?.scrollIntoView({behavior: "smooth"});
    }, [isLang])
    const startChatOnLanguageChange = () => {

        // if(message.length === 0){
        let lang = getCookie('prefLang')
        let sendData = {}
        if (prefLang != null) {
            sendData = {
                text: toUnicode("/st_greetings"),
                notification: 'N',
                locale: lang
            }
        }
        else {
            sendData = {
                text: toUnicode("/st_greetings"),
                notification: 'N',

            }
        }

        let obj = {};
        sendData.info = obj;
        if(window?.access_token){
            sendData.info.access_token = window.access_token;
        }
        if(window?.user_id){
            sendData.info.user_id = window.user_id;
        }
        setCookie("talkkChatState", 1, 1)
        setCookie('bot', botInfo?.data?.group?.id, 1);
        socket.emit(btoa(["user-send", sendData]));
        // }
    }
    const onEnd = () => {
        setPlaying("")
        cancel();
    };
    const { speak, voices, cancel} = useSpeechSynthesis({
        onEnd,
    });
    const allVoices = voices?.filter((f)=> (f.name.includes("Google") && !f.lang.includes("de-DE")) 
    || f.name.includes("Karen") || f.name.includes("Daniel") 
    || f.name.includes("Rishi") || f.name.includes("Samantha") 
    || f.name.includes("Tessa") || f.name.includes("Monica")
    || f.name.includes("Fred") || f.name.includes("Xander")
    || f.name.includes("Ellen") || f.name.includes("Lekha")
    || f.name.includes("Kanya"))

    const [playing, setPlaying] = useState("")
    var voiceLang = languages?.find(lang=>lang.value === prefLang)
    return (
        <>
            <div className="chat-header-wrapper">
                {process.env.REACT_APP_CLIENT === "GEMS" && <img src={GemsLogo} className='gems-h-logo' alt='gems-logo' />}
                <img src={botInfo?.data?.bot?.profileImagePath ? botInfo?.data?.bot?.profileImagePath : Epa} onError={(e) => ((e.target.src = Robot))} alt="icon" />
                <div className="bot-name-info-wrapper">
                    <h4 className="font-weight-bold">{ botCName ? botCName : botInfo?.data?.company?.companyName} <span className="bot icon-en" style={{ display: "none" }}></span> </h4>
                    {
                        startChat &&
                        <div className="chat-subheader-wrapper">
                            {botInfo?.data?.appInfo ? botInfo?.data?.appInfo?.widgetSubTitle : ""}
                        </div>
                    }
                </div>
                <div className="header-dropdown dropdown ml-auto">
                    <div className={`menu-icon ${startChat ? 'show-div' : 'hide-div'} ${(openFeedback === true || noFeedback === true) ? 'hide-div' : 'show-div'}`} onClick={() => setOpenMenu(!openMenu)}>
                        <i className="bot icon-menu"></i>
                    </div>
                    {
                        openMenu ? <div className="dd-overlay" onClick={() => setOpenMenu(false)}></div> : <></>
                    }
                    <div className={`dropdown-menu ${openMenu ? "show" : ""}`}>
                        {
                            startChat ?
                                <>
                                    {/* <div className="dropdown-divider"></div> */}
                                    {/* {
                                        botInfo?.data?.mobileAppConfig?.footerInfoMessage ?
                                            <div className="dropdown-item" onClick={()=> {setOpenMenu(!openMenu);setOpenInfoModal(true)}}><InfoOutlinedIcon /> Bot Info</div>
                                        :
                                            <></>
                                    } */}
                                    <div className="dropdown-item" onClick={closeChat}><CancelOutlinedIcon /> {botInfo?.data?.mobileAppConfig?.step26 ? botInfo?.data?.mobileAppConfig?.step26?.[prefLang] : "Close This Chat"}</div>
                                    {
                                        botInfo?.data?.bot?.language.length > 1 &&
                                        <>
                                            <div className="dropdown-divider"></div>
                                            <div className='dropdown-item no-hover'><GTranslateOutlinedIcon /> {botInfo?.data?.mobileAppConfig?.step25 ? botInfo?.data?.mobileAppConfig?.step25?.[prefLang] : "Change Language"}</div>
                                            <ul>
                                                {
                                                    hideFooter ?
                                                        <div className='section-blocked'></div>
                                                    : 
                                                        <></>
                                                }
                                                {
                                                    filteredLang?.map((item) => {
                                                        return <li className={`nav-item ${(prefLang === item.value) ? 'active' : ''}`} onClick={() => changeLanguageHanlder(item.value)}>{item.label === "Kreol " ? "Kreol (Trial)" : item.label}</li>
                                                    })
                                                }
                                            </ul>
                                        </>
                                    }
                                    {
                                        allVoices?.length > 0 && voiceEnabled && voiceLang?.lang_enable === "Y"  ?
                                            <>
                                                <div className="dropdown-divider"></div>
                                                <div className='dropdown-item' onClick={() => {setopenDrawer(true);setOpenMenu(false)}}><MicNoneOutlinedIcon />{botInfo?.data?.mobileAppConfig?.changeVoice ? botInfo?.data?.mobileAppConfig?.changeVoice?.[prefLang] : "Change Voice Assistant"}</div>

                                            </>
                                            :
                                            <></>
                                    }
                                </>
                                : null
                        }
                    </div>
                </div>
                <CloseIcon className="close-small-bot" onClick={() => setOpenBot(false)} />
                <div className='header-wave'>
                    <svg width="442" height="25" viewBox="0 0 442 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M94.5 4.5L2 3L441 3.5L411 11.5L375.5 17L330 21.5L283 23L232 20L199 17L168 13.5L141 10L115 7L94.5 4.5Z" fill="var(--header-bg-color)"/>
                        <path d="M1 5.04311C146.367 -6.23476 256.035 48.4749 441 3.5" stroke="var(--header-bg-color)" stroke-width="5"/>
                    </svg>
                </div>
            </div>
            {
                allVoices?.length > 0 ?
                    <>
                        {
                            openDrawer
                                ?
                                <div className="drawer-overlay" onClick={() => setopenDrawer(false)}></div>
                                :
                                <></>
                        }
                        <div className={`leave-message-wrapper list-drawer-wrapper ${openDrawer ? "show-leave-form" : ""}`}>
                            <div className="green-mark"></div>
                            <div className="drawer-header">
                                {"Please choose Voice assistant"}
                            </div>
                            <div className="drawer-body">
                                <div className="agent-list-wrapper voice-list-wrapper">
                                    {
                                        allVoices?.map(voice => {
                                            return (
                                                <div className={`agent-item voice-item mb-0 ${voice.name === getCookie("voiceAssistant") ? "active" : ""}`} onClick={()=>  {setPlaying(voice.name);cancel(); speak({ text: `Hello I am your virtual assistant`, voice: voice }); updateCookie("voiceAssistant", voice?.name)}}>
                                                    <span>{voice?.name}</span>
                                                    <div className='action-wrapper'>
                                                        {
                                                            voice?.name === playing ?
                                                                <PauseIcon onClick={()=>  {setPlaying(""); cancel()}} />
                                                            :
                                                                <PlayArrowIcon onClick={()=>  {setPlaying(voice.name);cancel(); speak({ text: `Hello I am your virtual assistant`, voice: voice })}}/>
                                                        }
                                                        <button type="button" className='btn btn-default' onClick={()=> {setopenDrawer(false); updateCookie("voiceAssistant", voice?.name)}}>Use</button>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <></>
            }
        </>
    )
}
export default Header;